function AnimationTitles() {
	this.build();
}

AnimationTitles.prototype.build = function () {

	// $('.title-animate').each(function () {
	// 	let element = $(this);
	//
	// 	let end = element.data('end') ? element.data('end') : '-30%';
	//
	// 	gsap.to(element, {
	// 		y: end,
	// 		ease: 'none',
	// 		scrollTrigger: {
	// 			trigger: element,
	// 			start: 'top bottom',
	// 			end: 'bottom top',
	// 			scrub: true
	// 		}
	// 	});
	// });



};
